import { useSelector } from 'react-redux'
import { groupSlice } from '../../slices/useGroupSlice'
import { FC } from 'react'
import { cn } from '@wellesley/ui'

type CmpProps = {
  className?: string
}

const GroupRules: FC<CmpProps> = ({ className }) => {
  const rules = useSelector(groupSlice.selectors.selectRules)

  return (
    <div className={cn('px-m py-m', className)}>
      {rules?.map((rule, index) => {
        const isLast = index === rules.length - 1

        return (
          <div key={rule.id}>
            <div
              className={cn('flex gap-xs', {
                'mb-s': !isLast,
              })}
            >
              <div className="flex size-m shrink-0 items-center justify-center rounded-full border border-gray-200 text-base font-semibold text-gray-900">
                {index + 1}
              </div>
              <div
                className={cn('flex-1 pb-s text-base', {
                  'border-b border-gray-200': !isLast,
                })}
              >
                <h3 className="mb-xxxs font-semibold text-gray-900">
                  {rule.text}
                </h3>
                <p className="text-gray-500">{rule.hint}</p>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default GroupRules
